// نسخة المتاجر (App Store / Google Play): تُخفي كل ما يتعلق بالشراء (تسجيل شركة، الأسعار، الفوترة، الرصيد)
// التزاماً بقاعدتي آبل 3.1.3(c)/(f) وسياسة "الاستهلاك فقط" في Google Play. الموقع helcoo.uk يبقى قناة البيع.
// حماية مزدوجة: متغيّر البناء REACT_APP_STORE_BUILD=true **أو** التشغيل داخل غلاف Capacitor أصلي،
// حتى لا يُرفع للمتجر بناء فيه أزرار شراء إذا نُسي المتغيّر. الويب والـ PWA لا يتأثران.
import { Capacitor } from "@capacitor/core";

const flagged = process.env.REACT_APP_STORE_BUILD === "true";
const native = (() => {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
})();

export const IS_STORE_BUILD = flagged || native;

// مسارات ممنوعة داخل نسخة المتاجر (تحوّل إلى الصفحة الرئيسية)
export const PURCHASE_ROUTES = ["/billing", "/wallet"];
export const PURCHASE_NAV_KEYS = ["billing", "wallet"];
